import React from "react";
import Marquee from "react-fast-marquee";
import Tooltip from "@mui/material/Tooltip";
import "./../../../styles/App.css";
import fb from "./../../../images/Facebook_Logo_2023.png";
import telegram from "./../../../images/telegram.png";
import insta from "./../../../images/Instagram_icon.png";
import yt from "./../../../images/Youtube_logo.png";
import x from "./../../../images/twitter.png";
import threads from "./../../../images/threads.png";
import daily from "./../../../images/dailymotion-png.png";
import hindu from "./../../../images/THEHINDU.jpg";
import WIRE from "./../../../images/WIRE.png";
import scroll from "./../../../images/SCROLL.png";
import newsminute from "./../../../images/newsminute.png";
import laundry from "./../../../images/CHIMTI.png";
import muslim from "./../../../images/MUSLIM MIRROR.png";
import express from "./../../../images/INDIAN EXPRESS.jpg";
import abp from "./../../../images/abp.png";
import deccan from "./../../../images/pngegg.png";
import herald from "./../../../images/DECCAN HERALD.png";
import bhaskar from "./../../../images/BHASKAR.png";
import print from "./../../../images/THEPRINT.png";
import guardian from "./../../../images/GUARDIAN.png";
import jazeera from "./../../../images/JAZEERA.png";
import ndtv from "./../../../images/NDTV.png";
import nbt from "./../../../images/NBT.png";
import RisingKashmir from "./../../../images/RisingKashmir.png";
import IndiaToday from "./../../../images/IndiaToday.png";
import TOI from "./../../../images/TOI.png";
import outlook from "./../../../images/outlook.jpg";
import "../../../styles/CardMarquee.css";

function CardCarousel({ socialMediaData }) {
  const cards = [
    { src: fb, tooltip: "Facebook", url: "https://www.facebook.com" },
    { src: x, tooltip: "Twitter", url: "https://www.twitter.com" },
    { src: yt, tooltip: "YouTube", url: "https://www.youtube.com" },
    { src: insta, tooltip: "Instagram", url: "https://www.instagram.com" },
    { src: threads, tooltip: "Threads", url: "https://www.threads.net" },
    { src: daily, tooltip: "Daily Motion", url: "https://www.dailymotion.com" },
    {
      src: TOI,
      tooltip: "Times Of India",
      url: "https://timesofindia.indiatimes.com",
    },
    { src: hindu, tooltip: "The Hindu", url: "https://www.thehindu.com" },
    { src: WIRE, tooltip: "The Wire", url: "https://thewire.in" },
    { src: scroll, tooltip: "Scroll", url: "https://scroll.in" },
    {
      src: newsminute,
      tooltip: "News Minute",
      url: "https://www.thenewsminute.com",
    },
    {
      src: laundry,
      tooltip: "News Laundry",
      url: "https://www.newslaundry.com",
    },
    { src: muslim, tooltip: "Muslim Mirror", url: "https://muslimmirror.com" },
    {
      src: express,
      tooltip: "Indian Express",
      url: "https://indianexpress.com",
    },
    { src: abp, tooltip: "ABP News", url: "https://www.abplive.com" },
    {
      src: deccan,
      tooltip: "Deccan Chronicle",
      url: "https://www.deccanchronicle.com",
    },
    {
      src: herald,
      tooltip: "Deccan Herald",
      url: "https://www.deccanherald.com",
    },
    { src: bhaskar, tooltip: "Dainik Bhaskar", url: "https://www.bhaskar.com" },
    { src: print, tooltip: "The Print", url: "https://theprint.in" },
    {
      src: guardian,
      tooltip: "The Guardian",
      url: "https://www.theguardian.com",
    },
    { src: jazeera, tooltip: "Al Jazeera", url: "https://www.aljazeera.com" },
    { src: ndtv, tooltip: "NDTV News", url: "https://www.ndtv.com" },
    {
      src: nbt,
      tooltip: "Nav Bharat Times",
      url: "https://navbharattimes.indiatimes.com",
    },
    {
      src: IndiaToday,
      tooltip: "India Today",
      url: "https://www.indiatoday.in",
    },
    {
      src: RisingKashmir,
      tooltip: "Rising Kashmir",
      url: "https://www.risingkashmir.com",
    },
    {
      src: outlook,
      tooltip: "Outlook India",
      url: "https://www.outlookindia.com",
    },
  ];

  // Duplicate cards to ensure seamless looping
  const loopingCards = [...cards, ...cards]; // Duplicate once

  return (
    <div className="marquee-container">
      <Marquee
        gradient={true} // Enable gradient
        gradientColor={[248, 251, 253]} // RGB color for the gradient
        speed={50}
        pauseOnHover={true}
        className="custom-marquee"
      >
        {loopingCards.map((card, index) => (
          <div key={index} className="marquee-card">
            <Tooltip title={card.tooltip} arrow>
              <a href={card.url} target="_blank" rel="noopener noreferrer">
                <img
                  src={card.src}
                  alt={card.tooltip}
                  className="marquee-img"
                />
              </a>
            </Tooltip>
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export default CardCarousel;
